// @flow

export const CHATBOT_PAYLOAD_KEY = 'chatchamp-chatbot-payload'
